"use client";

import React from "react";
import EditSection, { ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function EducaeetStatsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultStats = [
    { icon: "course", value: "1090+", label: "Our Online Courses", image: "" },
    { icon: "instructor", value: "120+", label: "Our Instructors", image: "" },
    { icon: "video", value: "120+", label: "Total Video Lessons", image: "" },
    { icon: "student", value: "6000+", label: "Total Students Enrolled", image: "" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700 font-mono">Stats Items</h4>
            <ListItemEditor
              label="Stats"
              items={content.stats || defaultStats}
              itemSchema={[
                { key: "value", label: "Value", type: "text" },
                { key: "label", label: "Label", type: "text" },
                { key: "icon", label: "Icon Name (course, instructor, video, student)", type: "text" },
                { key: "image", label: "Custom Image Upload", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, stats: items })}
              addItemText="Add Stat"
            />
          </div>
        </div>
      }
    />
  );
}
